export class ModuleDataHandler {
  moduleData: any;
  numberOfDay: any;

  constructor(moduleData: any, numberOfDay: any) {
    this.moduleData = moduleData;
    this.numberOfDay = numberOfDay;
  }

  //
  calculateAmount(rowIdx: number) {
    const { qty, rate } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'amount',
      Math.round((qty || 0) * (rate || 0))
    );
  }
  calculateTotalWeight(rowIdx: number) {
    const { qty, net_wt } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'total_wt',
      Math.round((qty || 0) * (net_wt || 0))
    );
  }
  calculateAMT(rowIdx: number) {
    const { total_wt } = this.getListData(rowIdx);
    this.updateListProperty(rowIdx, 'amt', Math.round((total_wt || 0) * 0.15));
  }

  // all totals function
  calculateTotal(key_name: any, update_key_name: any) {
    const total = this.moduleData?.list?.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue[key_name]) {
          return (+accumulator || 0) + (+currentValue[key_name] || 0);
        }
        return accumulator;
      },
      0
    );
    this.moduleData[update_key_name] = total;
  }

  handleSalaryCalc(rowIdx: number) {
    this.calculateAmount(rowIdx);
    this.calculateTotalWeight(rowIdx);
    this.calculateAMT(rowIdx);
  }

  private getListData(rowIdx: number) {
    return this.moduleData.list[rowIdx];
  }

  private updateListProperty(rowIdx: number, property: string, value: any) {
    this.moduleData.list[rowIdx][property] = value;
  }
}
